export default "__VITE_ASSET__edc1786c__"